import { connect } from 'react-redux';

import CommitmentUpsellBanner from '../components/sidebar/upsells/CommitmentUpsellBanner';
import { requestCommitmentUpsellModalVisibility } from '../actions';
import { hasOrderLineItemWithOfferingId } from '../selectors';

const mapStateToProps = (state, props) => {
  const {
    evergreenOffering,
    showRecommitCTAs = window.gon.current_store.preferences.show_recommit_ctas,
  } = props;

  return {
    lineItemsContainOfferingId: hasOrderLineItemWithOfferingId(
      state.currentOrder,
      evergreenOffering.id
    ),
    showRecommitCTAs,
    lineItems: state.currentOrder.line_items,
    isMembershipOrder: state.currentOrder.membership_order,
    userIsSubscribed: state.subscribed,
  };
};

const mapDispatchToProps = dispatch => ({
  handleAddToCartClick: () => {
    dispatch(requestCommitmentUpsellModalVisibility(true));
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CommitmentUpsellBanner);
